import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { LoginComponent } from './auth/login.component';
import { LogoutComponent } from './auth/logout.component';
import { SignupComponent } from './auth/signup.component';
import { ForgotPasswordComponent } from './auth/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PatientSummaryComponent } from './patients/patient-summary/patient-summary.component';
import { PatientsComponent } from './patients/patients.component';
import { RecordingComponent } from './recording/recording.component';
import { recordingCanDeactivateGuard } from './recording/recording-deactivate.guard';
import { PatientSummariesResolver } from './resolvers/patient-summaries.resolver';
import { SettingsComponent } from './settings/settings.component';
import { DevAdminComponent } from './devadmin/devadmin.component';
import { devadminGuard } from './devadmin/devadmin.guard';
import { TranscriptionDetailComponent } from './transcriptions/transcription-detail/transcription-detail.component';
import { TranscriptionsComponent } from './transcriptions/transcriptions.component';
import { subscriptionGuard } from './auth/subscription.guard';
import { SubscriptionRequiredComponent } from './subscription-required/subscription-required.component';
import { LegacyShellComponent } from './v0/legacy-shell.component';
import { AppShellComponent } from './shell/app-shell.component';
import { VisitsComponent } from './visits/visits.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { SettingsComingSoonComponent } from './shell/pages/settings-coming-soon.component';
import { PatientsWorkspaceComponent } from './patients/patients-workspace.component';

export const routes: Routes = [
  // Public auth (no app chrome)
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  
  // Subscription Wall
  { path: 'subscription-required', component: SubscriptionRequiredComponent, canActivate: [authGuard] },

  // Legacy UI - preserved under /v0 for comparison until redesign cutover cleanup
  {
    path: 'v0',
    component: LegacyShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'patients', component: PatientsComponent },
      { path: 'patients/:id', component: PatientSummaryComponent },
      { path: 'transcriptions', component: TranscriptionsComponent },
      { path: 'transcriptions/:id', component: TranscriptionDetailComponent },
      { path: 'settings', component: SettingsComponent },
      { path: 'devadmin', component: DevAdminComponent, canActivate: [devadminGuard] },
      {
        path: 'recording',
        component: RecordingComponent,
        
        canDeactivate: [recordingCanDeactivateGuard],
        resolve: {
          patientSummaries: PatientSummariesResolver,
        },
      },
    ],
  },

  // Bookmark redirects: old paths -> legacy /v0 during migration
  { path: 'transcriptions', redirectTo: 'v0/transcriptions', pathMatch: 'full' },
  { path: 'transcriptions/:id', redirectTo: 'v0/transcriptions/:id' },
  { path: 'devadmin', redirectTo: 'v0/devadmin', pathMatch: 'full' },

  // New default UI (left-rail shell)
  {
    path: '',
    component: AppShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', component: VisitsComponent },
      { path: 'dashboard', component: VisitsComponent },
      { path: 'patients', component: PatientsWorkspaceComponent },
      { path: 'patients/:id', component: PatientsWorkspaceComponent },
      { path: 'analytics', component: AnalyticsComponent },
      { path: 'analyzer', loadComponent: () => import('./analyzer/analyzer').then(c => c.AnalyzerComponent) },
      { path: 'analyzer/extension-guide', loadComponent: () => import('./analyzer/extension/extension-guide.component').then(c => c.ExtensionGuideComponent) },
      { path: 'settings', component: SettingsComingSoonComponent },
      { path: 'subscription', loadComponent: () => import('./subscription/subscription.component').then(c => c.SubscriptionComponent) },
      {
        path: 'recording',
        component: RecordingComponent,
        
        canDeactivate: [recordingCanDeactivateGuard],
        resolve: {
          patientSummaries: PatientSummariesResolver,
        },
      },
    ],
  },

  { path: '**', redirectTo: '' },
];
